export default "__VITE_ASSET__vNETQJwR__"